const API_URL = /(localhost|staging)/i.test(document.location.href)
  ? process.env.VUE_APP_BASE_API || 'https://staging-api.exandria.com/api'
  : 'https://api.exandria.com/api';

export default {
  API_URL,
  IMAGE_BASE_URL: API_URL.replace(/api$/, ''),
};
